// create a supabase auth controller that uses the env vars to setup a client 
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_PROJECT_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_API_KEY_PUBLIC;
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
